<app-auth-card
  (submitted)="onSubmit()"
  [buttonIcon]="'arrow-left'"
  [buttonLabel]="'Voltar'"
  [messageColor]="'#E41B2E'"
  [message]="'Usuário sem permissão!\nO usuário informado não possui permissão de acesso.'"
  [showButton]="true"
  [showLoading]="false"
></app-auth-card>

